"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _IconX = _interopRequireDefault(require("@instructure/ui-icons/lib/Solid/IconX"));

var _ScreenReaderContent = _interopRequireDefault(require("@instructure/ui-a11y/lib/components/ScreenReaderContent"));

var _uiTestable = _interopRequireDefault(require("@instructure/ui-testable"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _ThemeablePropTypes = _interopRequireDefault(require("@instructure/ui-themeable/lib/utils/ThemeablePropTypes"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _Button = _interopRequireDefault(require("../Button"));

var _theme = _interopRequireDefault(require("./theme"));

var _dec, _dec2, _class, _class2, _temp;

var styles = {
  componentId: 'ejhDx',
  template: function template(theme) {
    return "\n\n.ejhDx_bGBk{display:inline-block;z-index:".concat(theme.zIndex || 'inherit', "}\n\n.ejhDx_doBn{position:static}\n\n.ejhDx_bQpq,.ejhDx_bxia{position:absolute}\n\n.ejhDx_coHh{top:").concat(theme.offsetXSmall || 'inherit', "}\n\n.ejhDx_cDib{top:").concat(theme.offsetSmall || 'inherit', "}\n\n.ejhDx_faeR{top:").concat(theme.offsetMedium || 'inherit', "}\n\n.ejhDx_bQpq{inset-inline-end:0;inset-inline-start:auto}\n\n[dir=ltr] .ejhDx_bQpq{left:auto;right:0}\n\n[dir=rtl] .ejhDx_bQpq{left:0;right:auto}\n\n.ejhDx_bQpq.ejhDx_coHh{inset-inline-end:").concat(theme.offsetXSmall || 'inherit', ";inset-inline-start:auto}\n\n[dir=ltr] .ejhDx_bQpq.ejhDx_coHh{left:auto;right:").concat(theme.offsetXSmall || 'inherit', "}\n\n[dir=rtl] .ejhDx_bQpq.ejhDx_coHh{left:").concat(theme.offsetXSmall || 'inherit', ";right:auto}\n\n.ejhDx_bQpq.ejhDx_cDib{inset-inline-end:").concat(theme.offsetSmall || 'inherit', ";inset-inline-start:auto}\n\n[dir=ltr] .ejhDx_bQpq.ejhDx_cDib{left:auto;right:").concat(theme.offsetSmall || 'inherit', "}\n\n[dir=rtl] .ejhDx_bQpq.ejhDx_cDib{left:").concat(theme.offsetSmall || 'inherit', ";right:auto}\n\n.ejhDx_bQpq.ejhDx_faeR{inset-inline-end:").concat(theme.offsetMedium || 'inherit', ";inset-inline-start:auto}\n\n[dir=ltr] .ejhDx_bQpq.ejhDx_faeR{left:auto;right:").concat(theme.offsetMedium || 'inherit', "}\n\n[dir=rtl] .ejhDx_bQpq.ejhDx_faeR{left:").concat(theme.offsetMedium || 'inherit', ";right:auto}\n\n.ejhDx_bxia{inset-inline-end:auto;inset-inline-start:0}\n\n[dir=ltr] .ejhDx_bxia{left:0;right:auto}\n\n[dir=rtl] .ejhDx_bxia{left:auto;right:0}\n\n.ejhDx_bxia.ejhDx_coHh{inset-inline-end:auto;inset-inline-start:").concat(theme.offsetXSmall || 'inherit', "}\n\n[dir=ltr] .ejhDx_bxia.ejhDx_coHh{left:").concat(theme.offsetXSmall || 'inherit', ";right:auto}\n\n[dir=rtl] .ejhDx_bxia.ejhDx_coHh{left:auto;right:").concat(theme.offsetXSmall || 'inherit', "}\n\n.ejhDx_bxia.ejhDx_cDib{inset-inline-end:auto;inset-inline-start:").concat(theme.offsetSmall || 'inherit', "}\n\n[dir=ltr] .ejhDx_bxia.ejhDx_cDib{left:").concat(theme.offsetSmall || 'inherit', ";right:auto}\n\n[dir=rtl] .ejhDx_bxia.ejhDx_cDib{left:auto;right:").concat(theme.offsetSmall || 'inherit', "}\n\n.ejhDx_bxia.ejhDx_faeR{inset-inline-end:auto;inset-inline-start:").concat(theme.offsetMedium || 'inherit', "}\n\n[dir=ltr] .ejhDx_bxia.ejhDx_faeR{left:").concat(theme.offsetMedium || 'inherit', ";right:auto}\n\n[dir=rtl] .ejhDx_bxia.ejhDx_faeR{left:auto;right:").concat(theme.offsetMedium || 'inherit', "}");
  },
  'root': 'ejhDx_bGBk',
  'placement--static': 'ejhDx_doBn',
  'placement--end': 'ejhDx_bQpq',
  'placement--start': 'ejhDx_bxia',
  'offset--x-small': 'ejhDx_coHh',
  'offset--small': 'ejhDx_cDib',
  'offset--medium': 'ejhDx_faeR'
};

/**
---
category: components
---
**/
var CloseButton = (_dec = (0, _uiTestable.default)(), _dec2 = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = _dec2(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(CloseButton, _Component);

  function CloseButton() {
    (0, _classCallCheck2.default)(this, CloseButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CloseButton).apply(this, arguments));
  }

  (0, _createClass2.default)(CloseButton, [{
    key: "render",
    value: function render() {
      var _classnames;

      var _this$props = this.props,
          placement = _this$props.placement,
          offset = _this$props.offset;
      return _react.default.createElement("span", Object.assign({}, (0, _passthroughProps.omitProps)(this.props, CloseButton.propTypes), {
        className: (0, _classnames2.default)((_classnames = {}, (0, _defineProperty2.default)(_classnames, styles.root, true), (0, _defineProperty2.default)(_classnames, styles["placement--".concat(placement)], placement), (0, _defineProperty2.default)(_classnames, styles["offset--".concat(offset)], offset), _classnames))
      }), _react.default.createElement(_Button.default, Object.assign({}, (0, _passthroughProps.pickProps)(this.props, _Button.default.propTypes), {
        icon: _IconX.default
      }), _react.default.createElement(_ScreenReaderContent.default, null, this.props.children)));
    }
  }]);
  CloseButton.displayName = "CloseButton";
  return CloseButton;
}(_react.Component), _class2.propTypes = {
  children: _propTypes.default.node.isRequired,
  buttonRef: _propTypes.default.func,
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  onClick: _propTypes.default.func,
  margin: _ThemeablePropTypes.default.spacing,
  placement: _propTypes.default.oneOf(['start', 'end', 'static']),
  offset: _propTypes.default.oneOf(['none', 'x-small', 'small', 'medium']),
  variant: _propTypes.default.oneOf(['icon', 'icon-inverse'])
}, _class2.defaultProps = {
  onClick: function onClick(event) {},
  buttonRef: function buttonRef(el) {},
  variant: 'icon',
  placement: 'static',
  offset: 'x-small',
  size: 'small',
  margin: '0'
}, _temp)) || _class) || _class);
var _default = CloseButton;
exports.default = _default;